'use strict'

var kilroy = kilroy || {}
document.addEventListener('DOMContentLoaded', function () {
  var changeTicketForm = document.querySelector('#change-ticket-form')
  if (changeTicketForm) {
    const config = {
      errorBagName: 'errors', // change if property conflicts
      fieldsBagName: 'fields',
      delay: 0,
      locale: 'en',
      dictionary: null,
      strict: true,
      classes: true,
      classNames: {
        touched: 'touched', // the control has been blurred
        untouched: 'untouched', // the control hasn't been blurred
        valid: 'valid', // model is valid
        invalid: 'invalid', // model is invalid
        pristine: 'pristine', // control has not been interacted with
        dirty: 'dirty', // control has been interacted with
      },
      events: 'input|blur',
      inject: true,
      validity: false,
      aria: true,
      i18n: null, // the vue-i18n plugin instance
      i18nRootKey: 'validations', // the nested key under which the validation messsages will be located
    }

    const api = document.querySelector('#api').getAttribute('data-api')
    const market = document.querySelector('#market').getAttribute('data-market')
    const nodeId = document.querySelector('#nodeId').getAttribute('data-nodeId')
    const successUrl = document.querySelector('#successUrl').getAttribute('data-successUrl')

    Vue.use(VeeValidate, config)
    var changeTicketVue = new Vue({
      el: changeTicketForm,
      data: {
        isFetching : false,
        passengers: [{}],
        dates: [{}],
        route: {},
        comment: '',
        confirm: false,
        showDates: true,
        showRoutes: false,
        calendars: [],
        type: 'Date',
        bookingReference: '',
      },
      mounted() {
        this.initDatePicker()
        // this.initTermsOverlay();
      },
      methods: {
        addPassenger() {
          this.passengers.push({})
        },
        removePassenger(index) {
          this.passengers.splice(index, 1)
        },
        addDate() {
          this.dates.push({})
          Vue.nextTick()
            .then(() => {
              this.initDatePicker()
            })
        },
        removeDate(index) {
          this.dates.splice(index, 1)
          Vue.nextTick()
            .then(() => {
              this.initDatePicker()
            })
        },
        switchTabs() {
          if (this.showRoutes) {
            this.showDates = true
            this.showRoutes = false
            this.type = 'Date'
          } else {
            this.showDates = false
            this.showRoutes = true
            this.type = 'Route'
          }
          Vue.nextTick()
            .then(() => {
              this.initDatePicker()
            })
        },
        showTips(event) {
          //tab key
          if (event.keyCode == 9) {
            return
          }

          const element = event.currentTarget
          const parent = element.parentNode
          const error = parent.querySelector('.input-error')
          const tip = parent.querySelector('.input-tip')

          Vue.nextTick()
            .then(() => {
              if (document.activeElement === element) {
                if (element.classList.contains('invalid') && element.classList.contains('touched')) {
                  error.style.display = 'block'
                  tip.style.display = 'none'
                } else {
                  tip.style.display = 'block'
                  error.style.display = 'none'
                }
              }
            })

        },
        hideTips(event) {
          const element = event.currentTarget
          Vue.nextTick()
            .then(() => {
              // DOM updated
              const parent = element.parentNode
              const error = parent.querySelector('.input-error')
              const tip = parent.querySelector('.input-tip')
              error.style.display = 'none'
              tip.style.display = 'none'
            })

        },
        initDatePicker() {
          const self = this
          this.calendars = flatpickr('.js-datepicker:not(.flatpickr-input)', {
            minDate: 'today',
            dateFormat: "d/m/Y",
            disableMobile: true, // Disable mobile mode to solve UI issues ( missing placeholder )
            // onChange: function (selectedDates, dateStr, instance) {
            //     if (instance.input.classList.contains('newDate')) {
            //         console.log('test');
            //         const parent = instance.input.closest('.date');
            //         parent.querySelector('.notEarlierDate')._flatpickr.config.maxDate = dateStr;
            //         parent.querySelector('.notLaterDate')._flatpickr.config.minDate = dateStr;
            //     }
            // },
          })
        },
        validateAndSubmit() {
          if ( this.isFetching ) return

          this.$validator.validateAll().then((result) => {            
            if (result) {
              this.submit()
            }
          })
        },
        submit() {
          this.isFetching = true

          let extraPassengers = []
          for (let index = 1; index < this.passengers.length; index++) {
            const element = this.passengers[index]
            extraPassengers.push(
              {
                'firstname': element.firstName,
                'lastname': element.lastName,
              }
            )
          }

          const routeObj = this.showRoutes ? this.route : null
          const dateObj = this.showDates ? this.dates : null

          const data = {
            'market': market,
            'firstName': this.passengers[0].firstName,
            'lastName': this.passengers[0].lastName,
            'phoneNumber': this.passengers[0].phone,
            'email': this.passengers[0].email,
            'extraPassengers': extraPassengers,
            'changeTicketOrderType': this.type,
            'routeChange': routeObj,
            'dateChanges': dateObj,
            'comments': this.comment,
            'nodeId': nodeId,
            'bookingReference': this.bookingReference,
            
          }
          const cleanData = kilroy.helpers.sanitizeObject(data)

          
          axios({
            method: 'post',
            url: api,
            data: cleanData,
          }).then((response) => {
            if (response.status == 200) {
              window.location.href = successUrl
            } else {
              window.location.href = `${successUrl}?failed=true`
            }
            this.isFetching = false
          }).catch((error) => {
            // handle error
            this.isFetching = false
            window.location.href = `${successUrl}?failed=true`
          })
        },
      },
    })
  }

  const receiptPage = document.querySelector('#change-ticket-receipt')
  const failed = kilroy.helpers.getParameterByName('failed')
  if (receiptPage) {
    var receiptPagetVue = new Vue({
      el: receiptPage,
      data: {
        isFailed: failed === 'true' ? true : false,
      },
    })
  }
})
